// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"668":"b85fe90a","838":"6b166550"}[chunkId] + ".js";
};